import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import {
  EventListDisplayType,
  EVENT_LIST_DISPLAY_TYPE_TEASER,
  EVENT_LIST_DISPLAY_TYPE_TILE,
  EventListSearchResults,
} from '../EventListDetails.types';
import { EventListTable } from './EventListTable';
import { EventListTeaser } from './EventListTeaser';
import { EventListTiles } from './EventListTiles';

type EventListProps = {
  eventListDisplayType: EventListDisplayType;
  searchResults: EventListSearchResults;
};

function EventListDetailsDefault({ eventListDisplayType, searchResults }: EventListProps) {
  switch (eventListDisplayType) {
    case EVENT_LIST_DISPLAY_TYPE_TEASER:
      return <EventListTeaser searchResults={searchResults} />;
    case EVENT_LIST_DISPLAY_TYPE_TILE:
      return <EventListTiles searchResults={searchResults} />;
    default:
      return <EventListTable searchResults={searchResults} />;
  }
}

export const EventListDetailsDefaultView = asView(EventListDetailsDefault);
export type EventListDetailsDefaultView = ComponentProps<typeof EventListDetailsDefaultView>;
